import React from "react";
import cn from "classnames";
import { FormConsumer, FormProvider } from "../../molecules/Form/FormContext";
import "./FieldSet.less";

interface FieldSetProps {
    children: React.ReactNode;
    legend?: string;
    name?: string;
    noMargin?: boolean;
}

const FieldSet: React.FC<FieldSetProps> = ({ children, legend, name = "", noMargin = false }) => (
    <FormConsumer>
        {({ removeValue, setValue, inputPrefix, errors, values, visible, started }) => (
            <FormProvider
                value={{
                    removeValue,
                    setValue,
                    inputPrefix: `${inputPrefix} ${name}`.trim().replace(/\s/g, "-"),
                    errors: errors[name],
                    values: values[name],
                    visible: visible[name],
                    started: started[name],
                }}
            >
                <fieldset className={cn("rs-field-set", { "rs-field-set--no-margin": !!noMargin })} name={name}>
                    {legend && <legend className="rs-field-set__legend heading heading--level-2">{legend}</legend>}
                    {children}
                </fieldset>
            </FormProvider>
        )}
    </FormConsumer>
);

export default FieldSet;
